/***
 * Dashboard component that fetches and displays user-specific data
 * Shows key metrics
 * Uses React hooks for state and effect management
 */
import React, {useEffect, useState} from 'react';
import apiFetch from './apiClient';
import {KeyMetricsCard} from "./dashboard/KeyMetricsCard";
import {ShoppingListCard} from './dashboard/ShoppingListCard';
import {SpendingChartCard} from './dashboard/SpendingChartCard';

const Dashboard = () => {
    const [keyMetricsData, setKeyMetricsData] = useState(null);
    const [categoryShares, setCategoryShares] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const metricsResponse = await apiFetch('/api/dashboard/key-metrics');
                setKeyMetricsData(metricsResponse);
                const categoryResponse = await apiFetch('/api/dashboard/category-shares');
                setCategoryShares(categoryResponse);
            } catch (error) {
                console.error('Error fetching transactions data:', error);
            }
        };
        fetchData();
    }, []);

    return (
        <div className="min-vh-100 p-4">
            <div className="container-fluid content-custom">
                <div className="row g-4">
                    {/* Transaction List */}
                    <div className="col-12 col-lg-8">
                        <ShoppingListCard />
                    </div>
                    <div className="col-12 col-lg-4">
                        {/* Metrics Card */}
                        <div className='col-12'>
                            <KeyMetricsCard 
                                keyMetricsData = {keyMetricsData}
                            />
                        </div>
                        {/* Spending Chart */}
                        <div className='col-12 mt-4'>
                            <SpendingChartCard
                                categoryShares  = {categoryShares}
                                totalSpending = {keyMetricsData?.month_expenses?.[0]?.gastos_atuais}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;